'use strict';

import Loader from '../../../_modules/loader/loader';
import './_modernizr';
import { toaster } from './_material';
import { isFieldEmpty, isValidDecimal, displayErrors} from './_helper';

if ($('.view-institution').length) {

    let $body = $('body'),
        $addPayment = $('#AddPayment'),
        $inputAddPoNumber = $('#NewPoNumber'),
        $addCoPayment = $('#AddCoPayment'),
        $addInstitutionPays = $('#AddInstitutionPays'),
        $coPaymentWrap = $('.new-payment-type--co-payment'),
        $institutionPaymentWrap = $('.new-payment-type--institution-pays'),
        $paymentHospital1 = $('#InstitutionPays1'),
        $paymentClient1 = $('#ClientPays1'),
        $paymentHospital2 = $('#InstitutionPays2'),
        $paymentClient2 = $('#ClientPays2'),
        $fullPayInputsWrap1 = $('.full-payment1'),
        $fullPayInputsWrap2 = $('.full-payment2'),
        $percentageInputsWrap = $('.co-payment--percentage'),
        $flatFeeInputsWrap = $('.co-payment--flat-fee'),
        $reverseFeeInputsWrap = $('.co-payment--reverse-fee'),
        $flatPaymentHospital = $('#FlatPaymentHospital'),
        $flatPaymentClient = $('#FlatPaymentClient'),
        $percentageHospital = $('#PercentageHospital'),
        $percentageClient = $('#PercentageClient'),
        $newPaymentType = $('.new-payment-type'),
        $newPoNumber = $('.new-po-number'),
        loader = new Loader(),
        isMobileDevice = Modernizr.mq('(max-width: 767px)'),
        _isInvalid = [],
        dataParams = {},
        rowHTML = '',
        selectedInstitution = '',
        paymentType = '',
        paymentDesc = '',
        institutionPays = '',
        clientPays = '',
        poNumberId = '',
        paymentId = '';

    //Input dropdown to select Payment option
    $addPayment.on('change', function () {
        let payment = $addPayment.val();

        switch (payment) {
            case 'HP':
                $fullPayInputsWrap1.hide();
                $fullPayInputsWrap2.hide();
                $coPaymentWrap.hide();
                $institutionPaymentWrap.fadeIn();
                $paymentHospital2.val('100');
                $paymentClient2.val('0');
                break;

            case 'CO':
                $institutionPaymentWrap.hide();
                $fullPayInputsWrap2.hide();
                $fullPayInputsWrap1.hide();
                $coPaymentWrap.fadeIn();
                break;

            case '1':
                $institutionPaymentWrap.hide();
                $fullPayInputsWrap1.fadeIn();
                $coPaymentWrap.hide();
                $fullPayInputsWrap2.hide();
                $paymentHospital1.val('0');
                $paymentClient1.val('100');
                break;

            default:
                return false;
        }

        // set selected payment
        paymentType = payment;
        paymentDesc = $(this).find(':selected').text();
    });


    $addInstitutionPays.on('change', function () {
        let institutionPayment = $addInstitutionPays.val();

        switch (institutionPayment) {
            case '0':
                break;

            case '5':
                break;

            default:
                return false;
        }
        $fullPayInputsWrap2.fadeIn();

        // set selected payment
        paymentType = institutionPayment;
        paymentDesc = $(this).find(':selected').text();
    });

    //Input dropdown to select Co-Payment option
    $addCoPayment.on('change', function () {
        let coPayment = $addCoPayment.val();

        switch (coPayment) {
            case '4':
                $percentageInputsWrap.fadeIn();
                $reverseFeeInputsWrap.hide();
                $flatFeeInputsWrap.hide();
                break;

            case '2':
                $flatFeeInputsWrap.fadeIn();
                $percentageInputsWrap.hide();
                $reverseFeeInputsWrap.hide();
                break;

            case '3':
                $reverseFeeInputsWrap.fadeIn();
                $percentageInputsWrap.hide();
                $flatFeeInputsWrap.hide();
                break;

            default:
                return false;
        }

        // set selected payment
        paymentType = coPayment;
        paymentDesc = $(this).find(':selected').text();
    });

    $percentageHospital.on('keyup', function () {
        let $this = $(this);

        if ($this.val() > 100) {
            $this.val(100);
        } else if ($this.val() < 0) {
            $this.val(0);
        }

        $percentageClient.val(100 - $this.val());
    }).on('focus', function () {
        let $this = $(this);

        if ($(this).val() == 0) {
            $this.val('');
        }
    }).on('blur', function () {
        let $this = $(this);

        $this.val(Number($this.val()))
    });

    $percentageClient.on('keyup', function () {
        let $this = $(this);

        if ($this.val() > 100) {
            $this.val(100);
        } else if ($this.val() < 0) {
            $this.val(0);
        }

        $percentageHospital.val(100 - $this.val());
    }).on('focus', function () {
        let $this = $(this);

        if ($(this).val() == 0) {
            $this.val('');
        }
    }).on('blur', function () {
        let $this = $(this);

        $this.val(Number($this.val()))
    });

    //Display form to set new payment
    $('.js-add-new-payment').on('click', function (e) {
        e.preventDefault();

        $newPaymentType.slideToggle({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });

        //Unset all previous input values
        $('.js-add-payment').removeClass('error');
        $coPaymentWrap.hide();
        $fullPayInputsWrap1.hide();
        $fullPayInputsWrap2.hide();
        $percentageInputsWrap.hide();
        $flatFeeInputsWrap.hide();
        $reverseFeeInputsWrap.hide();
        $institutionPaymentWrap.hide();
        $addPayment.val('');
        $addCoPayment.val('');
        $percentageHospital.val(0);
        $percentageClient.val(0);
        $flatPaymentClient.val(0);
        $flatPaymentHospital.val(0);
    });



    $('.js-add-payment').on('click', function (e) {
        e.preventDefault();

        // Define where to display ajax errors
        let $errorContainer = $('.view-institution').find('.new-payment-type .server-errors__wrap'),
            paymentDetails = '';


        if (!isValidPayment()) {
            $(this).addClass('error');
            return false;
        } else {

            loader.fadeIn();
            $(this).removeClass('error');
        }


        // set amount: if percentage set amount as decimal, if flat fee set amount in cents
        switch (paymentType) {
            case '0':
                institutionPays = 1;
                clientPays = 0;
                paymentDetails = "Institution pays full amount";
                break;

            case '5':
                institutionPays = 1;
                clientPays = 0;
                paymentDetails = "Institution pays full amount";
                break;

            case '1':
                institutionPays = 0;
                clientPays = 1;
                paymentDetails = "Client pays full amount";
                break;

            case '4':
                institutionPays = $percentageHospital.val();
                clientPays = $percentageClient.val();
                paymentDetails = $percentageClient.val() + "%" + '/' + $percentageHospital.val() + "%";
                break;

            case '2':
                clientPays = $flatPaymentClient.val() * 100;
                institutionPays = null;
                paymentDetails = "Client pays first $" + Number($flatPaymentClient.val());
                break;

            case '3':
                institutionPays = $flatPaymentHospital.val() * 100;
                clientPays = null;
                paymentDetails = "Institution pays first $" + Number($flatPaymentHospital.val());
                break;
        }

        rowHTML = '';

        let $InstitutionId = parseInt($('#InstitutionId').val());

        dataParams = {
            "InstitutionId": $InstitutionId,
            "Type": parseInt(paymentType),
            "ClientPays": clientPays,
            "InstitutionPays": institutionPays
        };

        $errorContainer.slideUp({
            duration: 500,
            easing: 'easeInOutExpo',
            queue: false
        });

        $.ajax({
            url: '/api/institutions/addpaymentrule',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            type: 'POST',
            data: JSON.stringify(dataParams),
            success: function (data) {
                toaster('Payment rule has been added!');
                loader.fadeOut();

                $errorContainer.slideUp({
                    duration: 500,
                    easing: 'easeInOutExpo',
                    queue: false
                });

                $newPaymentType.slideToggle({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

                rowHTML += '<tr data-payment-id="' + data.Id + '"><td>';
                rowHTML += data.Type;
                rowHTML += '</td><td>';
                rowHTML += data.Value;
                rowHTML += '</td><td>';
                rowHTML += '<button type="button" data-value="Delete" class="btn btncta cta--form cta__tertiary js-delete-payment">Delete</button>';
                rowHTML += '</td></tr>';

                $('.view-institution table#payment_list tbody').append(rowHTML);
            },
            error: function (error) {
                loader.fadeOut();
                displayErrors(error, $errorContainer);
            }
        });
    });

    let isValidPayment = function (paymentSelected) {

        _isInvalid = [];

        //check if input has beens selected from dropdown
        if ($addPayment.val() == '') {
            $addPayment
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);

        } else if ($addPayment.val() == 'CO') {

            if ($addCoPayment.val() == '') {
                $addCoPayment
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

                _isInvalid.push(0);
            }
        }

        //Percentage inputs cannot be empty
        if ($addCoPayment.val() == 'Percentage') {
            let sum = Number($percentageHospital.val()) + Number($percentageClient.val());

            if (sum != 100) {
                $percentageHospital
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

                $percentageClient
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

                _isInvalid.push(0);
            }
        }

        if ($addCoPayment.val() == 'CFF') {
            let value = Number($flatPaymentClient.val());

            if (!isValidDecimal(value) || value === 0) {
                $flatPaymentClient
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

                _isInvalid.push(0);
            }
        }

        if ($addCoPayment.val() == 'IFF') {
            let value = Number($flatPaymentHospital.val());
            if (!isValidDecimal(value) || value === 0) {
                $flatPaymentHospital
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

                _isInvalid.push(0);
            }

        }

        if (_isInvalid.length > 0) {
            return false;
        } else {
            return true;
        }
    };

    $body.on('click', '.js-delete-payment', function (e) {
        e.preventDefault();

        let $this = $(this),
            $tr = $this.closest('tr');

        paymentId = $tr.data('payment-id');

        $.fancybox.open('#remove-payment', {
            autoSize: false,
            closeBtn: false,
            fitToView: false,
            height: isMobileDevice == true ? 300 : 200,
            width: isMobileDevice == true ? 250 : 500,
            padding: isMobileDevice == true ? 15 : [15, 25, 15, 25],
            type: 'inline',
            wrapCSS: 'modal'
        });
    }).on('click', '.js-confirm-delete-payment', function (e) {
        e.preventDefault();

        $.fancybox.close();

        let $InstitutionId = parseInt($('#InstitutionId').val());

        dataParams = {
            "PaymentRuleId": paymentId,
            "InstitutionId": $InstitutionId
        };

        let $errorContainer = $('.view-institution').find('table#payment_list').siblings('.server-errors__wrap');

        $errorContainer.slideUp({
            duration: 500,
            easing: 'easeInOutExpo',
            queue: false
        });

        loader.fadeIn();
        $.ajax({
            url: '/api/institutions/deletepaymentrule',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            type: 'POST',
            data: JSON.stringify(dataParams),
            success: function (data) {
                toaster('Payment rule has been deleted.');

                loader.fadeOut();

                $errorContainer.slideUp({
                    duration: 500,
                    easing: 'easeInOutExpo',
                    queue: false
                });

                $('.view-institution').find('tr[data-payment-id=' + paymentId + ']').slideUp({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false,
                    complete: function () {
                        $(this).remove();
                    }
                });
            },
            error: function (error) {
                loader.fadeOut();
                displayErrors(error, $errorContainer);
            }
        });
    });

    //Display form to set PO number
    $('.js-add-new-po').on('click', function (e) {
        e.preventDefault();

        $newPoNumber.slideToggle({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });

        //Unset all previous input values
        $('.js-add-new-po').removeClass('error');
        $inputAddPoNumber.val('');

    });

    let isValidPoNumber = function () {


        if ($inputAddPoNumber.val() == '') {
            $inputAddPoNumber
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);
        }

        if (_isInvalid.length > 0) {
            return false;
        } else {
            return true;
        }

    };

    $('.js-add-po-number').on('click', function (e) {
        e.preventDefault();

        // Define where to display ajax errors
        let $errorContainer = $('.view-institution').find('.new-po-number .server-errors__wrap');

        if (!isValidPoNumber()) {
            $(this).addClass('error');
            return false;
        } else {
            loader.fadeIn();
            $(this).removeClass('error');
        }

        let institutionId = parseInt($('#InstitutionId').val());

        let purchaseOrderNumber = $inputAddPoNumber.val();

        dataParams = {
            "InstitutionId": institutionId,
            "PurchaseOrderNumber": purchaseOrderNumber,
        };

        $errorContainer.slideUp({
            duration: 500,
            easing: 'easeInOutExpo',
            queue: false
        });
        rowHTML = '';
        $.ajax({
            url: '/api/institutions/addpurchaseordernumber',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            type: 'POST',
            data: JSON.stringify(dataParams),
            success: function (data) {
                toaster('Purchase Order number has been added!');
                loader.fadeOut();

                $errorContainer.slideUp({
                    duration: 500,
                    easing: 'easeInOutExpo',
                    queue: false
                });

                $newPoNumber.slideToggle({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

                rowHTML += '<tr data-po-number-id="' + data.Id + '"><td>';
                rowHTML += data.Value;
                rowHTML += '</td><td>';
                rowHTML += '<button type="button" data-value="Delete" class="btn btncta cta--form cta__tertiary js-delete-po">Delete</button>';
                rowHTML += '</td></tr>';

                $('.view-institution table#po_list tbody').append(rowHTML);
            },
            error: function (error) {
                loader.fadeOut();

                displayErrors(error, $errorContainer);
            }
        });
    });




    $body.on('click', '.js-delete-po', function (e) {
        e.preventDefault();

        let $this = $(this),
            $tr = $this.closest('tr');

        poNumberId = $tr.data('po-number-id');

        $.fancybox.open('#remove-po-number', {
            autoSize: false,
            closeBtn: false,
            fitToView: false,
            height: isMobileDevice == true ? 300 : 200,
            width: isMobileDevice == true ? 250 : 500,
            padding: isMobileDevice == true ? 15 : [15, 25, 15, 25],
            type: 'inline',
            wrapCSS: 'modal'
        });
    }).on('click', '.js-confirm-delete-po', function (e) {
        e.preventDefault();

        $.fancybox.close();

        let $InstitutionId = parseInt($('#InstitutionId').val());

        dataParams = {
            "PurchaseOrderNumberId": poNumberId,
            "InstitutionId": $InstitutionId
        };

        let $errorContainer = $('.view-institution').find('table#po_list').siblings('.server-errors__wrap');

        $errorContainer.slideUp({
            duration: 500,
            easing: 'easeInOutExpo',
            queue: false
        });

        loader.fadeIn();
        $.ajax({
            url: '/api/institutions/deletepurchaseordernumber',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            type: 'POST',
            data: JSON.stringify(dataParams),
            success: function (data) {
                toaster('PO number has been deleted.');

                loader.fadeOut();

                $errorContainer.slideUp({
                    duration: 500,
                    easing: 'easeInOutExpo',
                    queue: false
                });

                $('.view-institution').find('tr[data-po-number-id=' + poNumberId + ']').slideUp({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false,
                    complete: function () {
                        $(this).remove();
                    }
                });
            },
            error: function (error) {
                loader.fadeOut();
                displayErrors(error, $errorContainer);
            }
        });
    });

}
